module.exports = __webpack_public_path__ + "img/17.b86ec3ff.jpeg";